import{isObject as t}from"@guildeducationinc/type-guards";var r=function(r,e){return t(r)&&(!("__type"in r)||r.__type===e)};export{r as isBranded};
